import { render } from "./AnalyticsTypeBadge.vue?vue&type=template&id=79bb231c"
import script from "./AnalyticsTypeBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsTypeBadge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Analytics/AnalyticsTypeBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79bb231c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79bb231c', __exports__)) {
    api.reload('79bb231c', __exports__)
  }
  
  module.hot.accept("./AnalyticsTypeBadge.vue?vue&type=template&id=79bb231c", () => {
    api.rerender('79bb231c', render)
  })

}


export default __exports__